import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-wps-ng',
  template: ``,
  styles: [
  ]
})
export class WpsNgComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
